import { render, staticRenderFns } from "./OzCenterModal.vue?vue&type=template&id=ceee661a&scoped=true&"
import script from "./OzCenterModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzCenterModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OzCenterModal.vue?vue&type=style&index=0&id=ceee661a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceee661a",
  null
  
)

export default component.exports